import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-amazon-dsp-identity',
  templateUrl: './help-amazon-dsp-identity.component.html',
  styleUrls: ['./help-amazon-dsp-identity.component.scss']
})
export class HelpAmazonDspIdentityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
